import React from "react";
export const Hover = ({ onHover, children }) => (
    <div className="hover-component">
        <div className="hover-component__no-hover">{children}</div>
        <div className="hover-component__hover">{onHover}</div>
    </div>
);
